import { useEffect, useState } from 'react';

/**
 * Content-driven breakpoint (spec §4.2). Used to move the studio tools from a
 * bottom bar to a side rail. Deliberately not a device check — a narrow iPad
 * split-screen window gets the phone layout, which is the correct behaviour.
 */
export function useWide(query = '(min-width: 900px)') {
  const [wide, setWide] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = (e: MediaQueryListEvent) => setWide(e.matches);
    mq.addEventListener('change', on);
    setWide(mq.matches);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return wide;
}
